import { Middleware, combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import documentViewer from './documentViewer';
import profileSelector from './talentPoolSelectedProfile';
import jobRequisitionTabs from './jobRequisitionTabs';
// import userSlice from './userSlice';

const persistConfig = {
  key: 'root', // the key for storing the state in localStorage
  storage, // the storage mechanism
};

const modifiedSerializableCheck: Middleware[] = [];

const reducer = combineReducers({
  documentViewer: documentViewer.reducer,
  selectedTalentPoolProfile: profileSelector.reducer,
  jobRequisitionTabs: jobRequisitionTabs.reducer,
  // user: userSlice.reducer,

});
const persistedReducer = persistReducer(persistConfig, reducer);
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }).concat(modifiedSerializableCheck),
});

const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
export type AppRootState = ReturnType<typeof store.getState>;

export { store, persistor };
